export default __webpack_public_path__ + "static/image11-b460119e419ff87d0f0822d52999f22f.png";